import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { state, signal } from 'cerebral/tags'
import canOrder from 'utils/canOrder'
import { t } from '@billes/translator-client'

export default connect(
  {
    onBeforeAddToBasket: signal`basket.onBeforeAddToBasket`,
    group: state`app.user.group`
  },
  class BasketAddButton extends Component {
    onAddToBasket(e) {
      const { onBeforeAddToBasket, path } = this.props
      e.stopPropagation()
      onBeforeAddToBasket({ path })
    }

    render() {
      const { group, path } = this.props

      if (!canOrder(group)) {
        return null
      }
      return (
        <div title={t('bms.media.titles.addToBasket')}>
          <svg
            style={{
              position: 'absolute',
              top: 2,
              left: 2,
              cursor: 'pointer'
            }}
            viewBox={'-4 -6 24 24'}
            onClick={e => this.onAddToBasket(e)}
            onDoubleClick={e => {
              e.stopPropagation()
            }}>
            <path
              fill={'#fff'}
              d={
                'M14.173,7.087c0,0.686-0.556,1.24-1.241,1.24H8.327v4.606c0,0.686-0.556,1.24-1.241,1.24 c-0.342,0-0.652-0.139-0.876-0.363c-0.225-0.225-0.363-0.534-0.363-0.877V8.327H1.24c-0.343,0-0.652-0.139-0.877-0.363 C0.139,7.739,0,7.43,0,7.087c0-0.685,0.555-1.24,1.24-1.24h4.606V1.241C5.846,0.556,6.402,0,7.087,0c0.684,0,1.24,0.555,1.24,1.24 v4.606h4.606C13.619,5.847,14.172,6.402,14.173,7.087z'
              }
            />
          </svg>
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/Media/File/BasketAddButton/basketAddButton.js